module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-position": 'left',
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "160px"
    }
  }, [_c('div', {
    staticClass: "section-body"
  }, [_c('el-form-item', {
    attrs: {
      "label": "预约模式设置",
      "prop": "modelSetting"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.reservationMode),
      callback: function($$v) {
        _vm.$set(_vm.form, "reservationMode", $$v)
      },
      expression: "form.reservationMode"
    }
  }, _vm._l((_vm.reservationModes), function(item) {
    return _c('el-radio', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预约时间间隔",
      "prop": "interval"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.form.interval),
      callback: function($$v) {
        _vm.$set(_vm.form, "interval", $$v)
      },
      expression: "form.interval"
    }
  }, _vm._l((_vm.timeIntervals), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "资源位名称",
      "prop": "resourceName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "placeholder": "计师"
    },
    model: {
      value: (_vm.form.resourceName),
      callback: function($$v) {
        _vm.$set(_vm.form, "resourceName", $$v)
      },
      expression: "form.resourceName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预约周期",
      "prop": "maxLimitDay"
    }
  }, [_vm._v("\n        最多提前 "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    model: {
      value: (_vm.form.maxLimitDay),
      callback: function($$v) {
        _vm.$set(_vm.form, "maxLimitDay", $$v)
      },
      expression: "form.maxLimitDay"
    }
  }), _vm._v(" 天可预约")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "minLimitHour"
    }
  }, [_vm._v("\n        最少提前 "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    model: {
      value: (_vm.form.minLimitHour),
      callback: function($$v) {
        _vm.$set(_vm.form, "minLimitHour", $$v)
      },
      expression: "form.minLimitHour"
    }
  }), _vm._v(" 分钟可预约")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "取消预约条件",
      "prop": "cancelMinute"
    }
  }, [_vm._v("\n         到店前 "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    model: {
      value: (_vm.form.cancelMinute),
      callback: function($$v) {
        _vm.$set(_vm.form, "cancelMinute", $$v)
      },
      expression: "form.cancelMinute"
    }
  }), _vm._v(" 分钟可取消预约 (必须大于最小预约周期)\n      ")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预约条件",
      "prop": "condition"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.form.condition),
      callback: function($$v) {
        _vm.$set(_vm.form, "condition", $$v)
      },
      expression: "form.condition"
    }
  }, _vm._l((_vm.conditions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预约短信提醒",
      "prop": "sms_delay"
    }
  }, [_vm._v("\n        提前 "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    model: {
      value: (_vm.form.sms_delay),
      callback: function($$v) {
        _vm.$set(_vm.form, "sms_delay", $$v)
      },
      expression: "form.sms_delay"
    }
  }), _vm._v(" 小时发送短信提醒\n      ")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预约限制",
      "prop": "limitType"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.limitChange
    },
    model: {
      value: (_vm.form.limitType),
      callback: function($$v) {
        _vm.$set(_vm.form, "limitType", $$v)
      },
      expression: "form.limitType"
    }
  }, _vm._l((_vm.limitType), function(item) {
    return _c('el-radio', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.form.limitType == 'limit_days') ? _c('span', [_c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    model: {
      value: (_vm.form.limit),
      callback: function($$v) {
        _vm.$set(_vm.form, "limit", $$v)
      },
      expression: "form.limit"
    }
  }), _vm._v("天内可预约1次(从预约日开始算)\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.form.limitType == 'limit_nums') ? _c('span', [_vm._v("\n          1天内可预约 "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    model: {
      value: (_vm.form.limit),
      callback: function($$v) {
        _vm.$set(_vm.form, "limit", $$v)
      },
      expression: "form.limit"
    }
  }), _vm._v("次\n        ")], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-eae277f0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eae277f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/reservation/setting/index.vue
// module id = 2965
// module chunks = 0